import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Select } from "antd";
import { connect } from "react-redux";
import "./SelectCategories.scss";

const Option = Select.Option;

class SelectCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      privacy: "",
      category: "",
      categories: [],
      elements: [],
    };
  }

  componentDidMount() {
    const { draft } = this.props;
    const chatConfig = window.Social.getChatConfig();

    const contextList = this.props.contextList;

    let currentContext =
      contextList && contextList.length === 1 && contextList[0];
    let categoryFromCurrentContext;
    if (currentContext) {
      let currentElement = currentContext.find(
        (elem) => elem.description === chatConfig.hashElementPrefix
      );
      if (currentElement && currentElement.content) {
        categoryFromCurrentContext = chatConfig.hashElementInQuotes
          ? `#"${currentElement.content}"`
          : `#${currentElement.content}`;
      }
    }

    this.setState(
      {
        privacy: (draft && draft.privacy) || chatConfig.defaultPrivacy,
        category:
          (draft && draft.category) ||
          categoryFromCurrentContext ||
          chatConfig.defaultCategory,
        elements:
          (draft && draft.elements) ||
          (categoryFromCurrentContext && currentContext) ||
          [],
      },
      () => this.props.onCategoryChange(this.state)
    );

    let categories = [{ name: chatConfig.defaultCategory, elements: [] }];
    if (contextList && contextList.length) {
      for (
        let i = 0, contextListLen = contextList.length;
        i < contextListLen;
        i++
      ) {
        let context = contextList[i];
        let element = context.find(
          (elem) => elem.description === chatConfig.hashElementPrefix
        );

        element &&
          categories.push({
            name: chatConfig.hashElementInQuotes
              ? `#"${element.content}"`
              : `#${element.content}`,
            elements: context,
          });
      }
    }

    this.setState({
      categories: categories,
    });
  }

  componentDidUpdate(prevProps) {
    const chatConfig = window.Social.getChatConfig();
    if (this.props.contextList !== prevProps.contextList) {
      let categories = [{ name: chatConfig.defaultCategory }];
      if (this.props.contextList) {
        for (
          let i = 0, contextListLen = this.props.contextList.length;
          i < contextListLen;
          i++
        ) {
          let context = this.props.contextList[i];
          let element = context.find(
            (elem) => elem.description === chatConfig.hashElementPrefix
          );

          element &&
            categories.push({
              name: `#${element.content}`,
              elements: context,
            });
        }
      }
      this.setState({
        categories: categories,
        category: chatConfig.defaultCategory,
      });
    }
  }

  onPrivacyChange(value) {
    this.setState(
      {
        privacy: value,
      },
      () => this.props.onCategoryChange(this.state)
    );
  }

  onCategoryChange(value, option) {
    this.setState(
      {
        category: value,
        elements:
          (option.props.element &&
            option.props.element.elements &&
            option.props.element.elements) ||
          [],
      },
      () => this.props.onCategoryChange(this.state)
    );
  }

  getChildren() {
    let children = [];

    for (
      let i = 0, categoriesLength = this.state.categories.length;
      i < categoriesLength;
      i++
    ) {
      let category = this.state.categories[i];
      children.push(
        <Option
          key={i}
          title={category.name}
          value={category.name}
          element={category}
        >
          <span className="title">{category.name}</span>
          <span className="description">{category.alias}</span>
        </Option>
      );
    }
    return children;
  }

  getPrivacyOptions() {
    let privacyPolicy = window.Social.getPrivacyTypesConfig();
    let options = [];
    for (let i in privacyPolicy) {
      let currentPrivacy = privacyPolicy[i];
      let currentTitle = this.props.intl.formatMessage({
        id: currentPrivacy.title,
      });
      options.push(
        <Option
          title={currentTitle}
          value={currentPrivacy.value}
          key={currentPrivacy.value}
        >
          <span className="title">{currentTitle}</span>
          <span className="description">
            {this.props.intl.formatMessage({ id: currentPrivacy.description })}
          </span>
        </Option>
      );
    }
    return options;
  }

  canSelectPrivacy() {
    if (
      this.state.category === window.Social.getChatConfig().defaultCategory &&
      window.Social.getChatConfig().defaultCategoryPrivacyLock
    )
      return false;
    return !this.props.disabled;
  }

  render() {
    let canSelectPrivacy = this.canSelectPrivacy();
    return (
      <div className="select-categories">
        <Select
          className="select-privacy"
          dropdownStyle={{ paddingLeft: 5 }}
          value={this.state.privacy}
          onSelect={this.onPrivacyChange.bind(this)}
          optionLabelProp="title"
          dropdownMatchSelectWidth={false}
          dropdownClassName="select-privacy-dropdown"
          getPopupContainer={() => this.privacyRef}
          disabled={!canSelectPrivacy}
          showArrow={canSelectPrivacy}
        >
          {this.getPrivacyOptions()}
        </Select>
        <div
          className="dropdown-container"
          ref={(node) => (this.privacyRef = node)}
        ></div>
        <Select
          className="select-category"
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          optionLabelProp="title"
          value={this.state.category}
          onSelect={this.onCategoryChange.bind(this)}
          dropdownMatchSelectWidth={false}
          dropdownClassName="select-categories-dropdown"
          getPopupContainer={() => this.categoryRef}
          disabled={!!this.props.disabled}
        >
          {this.getChildren()}
        </Select>
        <div
          className="dropdown-container"
          ref={(node) => (this.categoryRef = node)}
        ></div>
      </div>
    );
  }
}

const mapStateToProps = ({ Api, GeneralSettings }) => {
  return {
    dynamicMessageFilter: GeneralSettings.dynamicMessageFilter,
    contextList: Api.contextList,
  };
};

export default connect(mapStateToProps)(injectIntl(SelectCategories));
